class MoneyFormat extends HTMLElement {
  static ratesPromise = null;

  async connectedCallback() {
    const rawValue = this.textContent.trim();
    const cents = parseInt(rawValue, 10);
    if (isNaN(cents)) return;

    const baseCurrency = this.dataset.baseCurrency || "USD";
    const targetCurrency =
      window.Shopify?.currency?.active ||
      window.Shopify?.currency?.shop_currency ||
      "USD";

    const locale = document.documentElement.lang || navigator.language || "en-US";
    const zeroDecimalCurrencies = ["BIF", "CLP", "DJF", "GNF", "JPY", "KMF", "KRW", "MGA", "PYG", "RWF", "UGX", "VND", "VUV", "XAF", "XOF", "XPF"];

    let amount = cents / 100;

    if (baseCurrency !== targetCurrency) {
      try {
        const rates = await this.getRates(baseCurrency);
        const rate = rates?.[targetCurrency];

        if (rate) {
          amount = amount * rate;
        } else {
          console.warn(`No exchange rate found for ${baseCurrency} to ${targetCurrency}`);
        }
      } catch (error) {
        console.warn("Currency conversion failed", error);
      }
    }

    const decimals = zeroDecimalCurrencies.includes(targetCurrency) ? 0 : 2;

    let formatted = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: targetCurrency,
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(amount);

    formatted = formatted.replace(/\.00$/, "").replace(/,00$/, "");

    this.textContent = formatted;
  }

  async getRates(baseCurrency) {
    if (!MoneyFormat.ratesPromise) {
      MoneyFormat.ratesPromise = fetch(`https://open.er-api.com/v6/latest/${baseCurrency}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.result !== "success") throw new Error("Invalid exchange response");
          return data.rates;
        });
    }

    return MoneyFormat.ratesPromise;
  }
}

if (!customElements.get("money-format")) {
  customElements.define("money-format", MoneyFormat);
}